import * as actionTypes from 'constants/ActionTypes';

const vessels = (
    state = {
        isLoaded: false,
        isNameSuggestion: false,
        suggestionSource: 'all',
        notConfirmed: false,
        isMarkedToDelete: false,
        sanctioned: undefined,
        filterCargoExclusions: undefined,
        filterTradingRestrictions: undefined,
        modifiedFilter: 'all',
        photosFilter: 'all',
        typeByPurpose: '',
        dwtMin: null,
        dwtMax: null,
        sortField: 'name',
        sortValue: 1, 
        limit: 25,
        page: 1,
        data: [],
    },
    action,
) => {
    switch (action.type) {
    case actionTypes.GET_VESSELS.REQUEST:
        return {
            ...state,
            ...action.pagination,
        };
    case actionTypes.GET_VESSELS.SUCCESS: {
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    }
    case actionTypes.GET_VESSELS.FAILURE:
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    default:
        return state;
    }
};

export default vessels;



// WEBPACK FOOTER //
// ./app/reducers/vessels/vessels.js